import repositories from '..';

const resource = '/subject/subjects';

export default {
  getInitData: () => repositories.get(`${resource}/data/init`),
};
